var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2474 11.5L16.739 8.00842C16.9047 7.843 16.9979 7.61853 16.9981 7.38439C16.9983 7.15025 16.9055 6.92562 16.7401 6.75991C16.5747 6.5942 16.3502 6.50099 16.1161 6.50078C15.8819 6.50057 15.6573 6.59339 15.4916 6.7588L12 10.2504L8.50842 6.7588C8.34271 6.59309 8.11796 6.5 7.88361 6.5C7.64926 6.5 7.42451 6.59309 7.2588 6.7588C7.09309 6.92451 7 7.14926 7 7.38361C7 7.61796 7.09309 7.84271 7.2588 8.00842L10.7504 11.5L7.2588 14.9916C7.09309 15.1573 7 15.382 7 15.6164C7 15.8507 7.09309 16.0755 7.2588 16.2412C7.42451 16.4069 7.64926 16.5 7.88361 16.5C8.11796 16.5 8.34271 16.4069 8.50842 16.2412L12 12.7496L15.4916 16.2412C15.6573 16.4069 15.882 16.5 16.1164 16.5C16.3507 16.5 16.5755 16.4069 16.7412 16.2412C16.9069 16.0755 17 15.8507 17 15.6164C17 15.382 16.9069 15.1573 16.7412 14.9916L13.2474 11.5Z",
    fill: "#0C0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCloseIcon);
export default __webpack_public_path__ + "static/media/popup-close-icon.a76d892451dd6ee9f920ff753e74a980.svg";
export { ForwardRef as ReactComponent };